export const MINIMAL_ORIGIN_LENGTH_FOR_EXTRACTION = 20;
